import request from '@/utils/request'
import personal from '@/views/systemManage/personal.vue'

export function loginByUsername(username, password, checkCode, deviceId) {
  const data = {
    username,
    password
  }
  return request({
    url: '/oauth/user/token',
    method: 'post',
    data: data,
    headers: {'validCode': checkCode, 'deviceId': deviceId}
  })
}

export function logout(accessToken) {
  return request({
    url: '/oauth/remove/token/' + accessToken,
    method: 'get'
  })
}

export function getUserInfo() {
  return request({
    url: '/oauth/userinfo',
    method: 'get'
  })
}

export function requestQueryMenu() {
  return request({
    url: '/menus/current',
    method: 'get'
  })
}
// 处理菜单数据
export function dealMenuData (data) {
  let list = []
  if (data) {
    for (let i = 0, j = data.length; i < j; i++) {
      if (data[i].type == 1) {
        // type为1，childMenus表示子菜单页，childMenus.childMenus表示权限
        // type为2，表示没有子菜单页，childMenus表示权限
        let children = []
        if (data[i].childMenus) {
          const childMenus = data[i].childMenus
          for (let m = 0, n = childMenus.length; m < n; m++) {
            let child = childMenus[m]
            // 对应的权限
            if (childMenus[m].childMenus) {
              const permission = childMenus[m].childMenus.map(item => {
                const name = item.name
                return name
              })
              child.permission = permission
            }
            children.push(child)
          }
        }
        const listData = Object.assign(data[i], {children: children})
        list.push(listData)
      } else {
        let permission = []
        if (data[i].childMenus) {
          const childMenus = data[i].childMenus
          let children = []
          permission = childMenus.map(item => {
            const name = item.name
            return name
          })
        }
        const listData = Object.assign(data[i], {permission: permission})
        list.push(listData)
      }
    }
  }
  console.log('routerList', list)
  return list
}
// 菜单配置
export function routerMatch(permission, asyncRouter) {
  return new Promise((resolve) => {
    const routers = []
    // 创建路由
    function createRouter(permission, router) {
        // 根据路径匹配到的router对象添加到routers中即可
      if(permission && permission.length > 0) {
        permission.forEach(item => {
          if(item.children && item.children.length > 0) {
            // 将接口返回的路由与本地配置的路由比较，找到name相同的并返回
            // nestRouter存的是接口返回的路由和本地写的路由有着相同的路由名字
            const nestRouter = router.find(r => r.name === item.name)
            if(nestRouter && nestRouter.children) {
              const filterChildRouters = []
              item.children.forEach((v, i) => {
                // nestRouter里面找到path相同的，再给这些相同的路由加上meta，里面存的是权限
                const filterRouter = nestRouter.children.find(n => n.path === v.path)
                if (filterRouter) {
                  filterRouter.meta.permission = item.children[i].permission
                  filterChildRouters.push(filterRouter)
                }
              })
              console.log('---nestRouter---', nestRouter, filterChildRouters)
              nestRouter.children = [...filterChildRouters]
              // 将89行匹配到的路由再与本地的路由合并，使用这个routes
              routers.push(nestRouter)
            }
          } else {
            let path = item.path
            router.forEach((s) => {
              if (s.path === '/' || s.path === '') {
                s.children.forEach((y) => {
                  if (y.path === path) {
                    y.meta.permission = item.permission;
                    routers.push(s)
                  }
                })
              } else if(s.path === path) {
                s.meta.permission = item.permission;
                routers.push(s)
              } else {}
            })
          }
        })
      }
      // permission.forEach((item) => {
      //   if (item.children && item.children.length) {
      //     createRouter(item.children)
      //   }
      //   let path = item.path;
      //   // 循环异步路由，将符合权限列表的路由加入到routers中
      //   asyncRouter.find((s) => {
      //     if (s.path === '/' || s.path === '') {
      //       s.children.find((y) => {
      //         if (y.path === path) {
      //           y.meta.permission = item.permission;
      //           routers.push(s);
      //         }
      //       })
      //     }
      //     if (s.path === path && !(s.path === '/' || s.path === '')) {
      //       s.meta.permission = item.permission;
      //       routers.push(s);
      //     }
      //   })
      // })
    }
    createRouter(permission, asyncRouter)
    console.log(routers, '---> 根据后端返回匹配到的路由');
    resolve([routers])
  })
}
// 菜单
export function filterAsyncRouter(constantWhiteRouterMap) {
  return new Promise((resolve) => {
     const routers = [];
    // 创建路由
    function createRouter(constantWhiteRouterMap) {
        // 根据路径匹配到的router对象添加到routers中即可
        // asyncRouterMap.forEach((item) => {
        // if (item.children && item.children.length) {
        //   createRouter(item.children)
        // }
        // let path = item.path;
        // 循环异步路由，将符合权限列表的路由加入到routers中
        // asyncRouterMap.find((s) => {
        //   routers.push(s);
        // })
        constantWhiteRouterMap.find((s) => {
          routers.push(s);
        })
    }
    createRouter(constantWhiteRouterMap)
    resolve([routers])
  })
}



// WEBPACK FOOTER //
// ./src/api/login.js